import { app } from '../../../../app';
import { Controller } from './application-users.controller';

app.component('companyManageApplicationUsers', {
    bindings: {
        application: '<',
        companyId: '<',
        groups: '<',
    },
    controller: Controller,
    templateUrl: require('./application-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/application-users.component.js